import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

const AlertMessage = ({ message = '' }) => (
  <div className="alert-message-wrapper">
    <span>{message}</span>
    <style jsx>{styles}</style>
  </div>
);

AlertMessage.propTypes = {
  message: PropTypes.string
};

export default AlertMessage;
